import { Component, EventEmitter, Inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import html2canvas from 'html2canvas';
import { AngularModalService } from 'src/app/core/services/modal.service';

declare var $: any;

@Component({
  selector: 'app-job-boards-supported-parameters',
  templateUrl: './job-boards-supported-parameters.component.html',
  styleUrls: ['./job-boards-supported-parameters.component.css']
})
export class JobBoardsSupportedParametersComponent {

  @Input() job: any;
  @Input() isEditable: any;
  @Input() readOnlyJobBoardsData: any;
  @Input() resumePullOptions: any;
  @Input() radiusOptions: any;
  @Input() recencyOptions: any;
  @Input() savedResumePullCount: any;
  @Input() activeFilterTab: any;
  @Input() context: any;
  @Output() jobBoardsSelectionChange = new EventEmitter<void>();
  @Output() saveCallback = new EventEmitter<void>();

  @ViewChild('searchInterfaceModal') searchInterfaceModal: TemplateRef<any>;
  @ViewChild('searchHistoryModal') searchHistoryModal: TemplateRef<any>;

  loadingSearchInterfaceFlag = true;
  savingFlag = false;
  searchHtml: any = '';

  private searchInterfaceModalRef: BsModalRef = null;
  private searchHistoryModalRef: BsModalRef = null;

  constructor(
    private sanitizer: DomSanitizer,
    private jobService: JobService,
    private bsModalService: BsModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private modalService:AngularModalService
  ) { }

  onJobBoardSelectionChange() {
    this.jobBoardsSelectionChange.emit();
  }

  clearJobBoardsSearchFilters() {
    this.alertsAndNotificationsService.showConfirm(
      'Confirm', 'Are you sure you want clear the advanced filters?', 'warning', true,
      () => {
        this.jobService.removeDaxtraParameters(this.job.id, () => {
          this.job.daxtraParameters = null;
          this.alertsAndNotificationsService.showAlert('Success!', 'Job Boards Filters Cleared Successfully', 'success');
        }, () => {
          this.alertsAndNotificationsService.showAlert('Error!', 'Job Boards Filters Clear Failed', 'danger');
        });
      },
      null
    );
  }

  getJobBoardSearchInterface() {
    let jobBoardCodes = '';
    (this.job.jobBoardDetails || []).forEach((val) => {
      if (val.enabled) {
        jobBoardCodes = jobBoardCodes === '' ? val.daxtraCode : jobBoardCodes + ',' + val.daxtraCode;
      }
    });
    if (jobBoardCodes === '') {
      this.alertsAndNotificationsService.showAlertWithCallBack('No Job Boards Selected!', 'Please select at least one job board to perform this action.', 'warning', () => {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
      return;
    }

    this.loadingSearchInterfaceFlag = true;
    this.savingFlag = false;
    this.searchHtml = '';

    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-medium';
    config.backdrop = 'static' as any;
    this.searchInterfaceModalRef = this.bsModalService.show(this.searchInterfaceModal, config);

    const searchObject: any = {
      dbCode: 'jw_fourdotfive',
      jobBoardCodes,
      jsLib: 'jquery',
      libs: 'css,jb_params_jq,jquery-ui',
      ajaxAutoCompleter: 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_completer.pl',
      ajaxUpdater: 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_ajax.pl',
      jsonp: true,
      relayParam: 'daxtra.com'
    };

    this.jobService.getJobBoardSearchInterface(searchObject, (data) => {
      this.searchHtml = this.sanitizer.bypassSecurityTrustHtml(data.t.htmlContent);
      const searchJobParamsJS = '<script>' + data.t.jbParamsJq + '</script>';
      const searchJS = '<script>' + data.t.jsContent + '</script>';
      const searchCSS = '<style>' + data.t.cssContent + '</style>';
      $('#dynamicContentForJobBoardSearch').append(searchCSS);
      $('#dynamicContentForJobBoardSearch').append(searchJobParamsJS);
      $('#dynamicContentForJobBoardSearch').append(searchJS);
      this.loadingSearchInterfaceFlag = false;
      setTimeout(() => {
        $("label:contains('Max results')").remove();
        $("select[name$='_max_results']").remove();
      }, 500);
    }, (error) => {
      this.loadingSearchInterfaceFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  closeSearchInterfaceModal() {
    if (this.searchInterfaceModalRef) {
      this.searchInterfaceModalRef.hide();
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    }
  }

  saveAdvancedSearchParams() {
    this.savingFlag = true;
    const advancedSearchArray = $('#jobBoardSearchForm').serializeArray();
    const advancedSearchObject: any = {};
    advancedSearchArray.forEach((val) => {
      advancedSearchObject[val.name] = val.value;
    });

    $('#daxtra-ui').scrollTop('0px');
    setTimeout(() => {
      html2canvas(document.querySelector('#jb_params') as HTMLElement).then((canvas) => {
        const imageData = canvas.toDataURL('image/png');
        advancedSearchObject.image = imageData.replace(/^data:image\/png/, 'data:application/octet-stream');
        this.jobService.saveDaxtraParameters(this.job.id, advancedSearchObject, (data) => {
          this.savingFlag = false;
          this.alertsAndNotificationsService.showAlertWithCallBack(
            'Success!',
            "<span>Advanced Search Parameters saved successfully.</span></br> <span>Hit 'Next' to initiate search and pull candidates.</span>",
            'success',
            () => {
              this.closeSearchInterfaceModal();
              this.loadDaxtraParametersAndImage(data.daxtraParameters, data.advancedParametersImage);
            }
          );
        }, (error) => {
          this.savingFlag = false;
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      });
    }, 2000);
  }

  loadDaxtraParametersAndImage(params, image) {
    this.job.daxtraParameters = params;
    this.job.advancedParametersImage = this.sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  launchJobBoardSearchHistory() {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-medium';
    config.backdrop = 'static' as any;
    this.searchHistoryModalRef = this.bsModalService.show(this.searchHistoryModal, config);
  }

  closeSearchHistoryModal() {
    if (this.searchHistoryModalRef) {
      this.searchHistoryModalRef.hide();
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    }
  }
}
